// const env = {
//     url: 'http://localhost:8000/',
//     api: 'http://localhost:8000/api/v1/app/',
//     baseUrl: 'http://localhost:8080/',
//     title: 'Admin | AXS Consultoria',
// }


const env = {
    baseUrl: 'https://app.assetaxs.com/',
    url: 'https://api.assetaxs.com/',
    api: 'https://api.assetaxs.com/api/v1/app/',
    title: 'Admin | Asset AXS Consultoria',
}


export default env;
